import { render, staticRenderFns } from "./UpperFloor.html?vue&type=template&id=5838850a&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./UpperFloor.scss?vue&type=style&index=0&id=5838850a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838850a",
  null
  
)

export default component.exports